import { useState } from "react";
import { faqs } from "@/mocks/manga";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-16 md:py-24">
      <div className="mx-auto max-w-3xl px-4 md:px-6">
        <div className="flex flex-col items-center text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-500/15 px-4 py-1.5 text-sm font-medium text-accent-600">
            <i className="ri-question-line"></i>
            追漫指南
          </span>
          <h2 className="mt-4 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
            常见问题
          </h2>
          <p className="mt-3 max-w-xl text-base text-foreground-700">
            关于观看方式、更新频率与追更提醒，这里都有答案。
          </p>
        </div>

        <div className="mt-12 space-y-3">
          {faqs.map((item, idx) => {
            const open = openIndex === idx;
            return (
              <div
                key={item.q}
                className="overflow-hidden rounded-xl border border-background-200/70 bg-background-100/50"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? null : idx)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <h3 className="text-base font-medium text-foreground-950">{item.q}</h3>
                  <i
                    className={`text-lg text-primary-500 transition-transform duration-300 ${
                      open ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </button>
                {open && (
                  <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-700">{item.a}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}